import { ITreeStructure } from '../models/treeStructure'

export const getLeaves = (original: ITreeStructure[]): ITreeStructure[] => {
  return original.filter((el) => !el.hasChildren)
}
